import { render } from "./PedidosCambiosListado.vue?vue&type=template&id=7d67cc32"
import script from "./PedidosCambiosListado.vue?vue&type=script&lang=js"
export * from "./PedidosCambiosListado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__